import React from 'react';
import { useContent } from '../content/ContentContext';
import { Reveal, SectionHeader } from '../lib/ui';

const Services: React.FC = () => {
  const { services } = useContent();
  if (!services.visible) return null;

  return (
    <section id="leistungen" className="scroll-mt-20 border-t border-line py-24 md:py-32">
      <div className="container-site">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <SectionHeader eyebrow={services.eyebrow} title={services.title} intro={services.intro} />
          </div>
          <ol className="grid gap-px overflow-hidden rounded-3xl border border-line bg-line lg:col-span-7 sm:grid-cols-2">
            {services.items.map((item, i) => (
              <li key={item.title} className="bg-surface p-7 sm:p-8">
                <Reveal delay={i * 0.06}>
                  <span className="text-[13px] font-medium tabular-nums text-accent">{String(i + 1).padStart(2, '0')}</span>
                  <h3 className="mt-3 text-lg font-semibold tracking-tight">{item.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-fg-2">{item.description}</p>
                </Reveal>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Services;
